import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import selectors from '../selectors';
import entryActions from '../entry-actions';
import Projects from '../components/Projects';
import { ResourceTypes, Permissions } from '../constants/Enums';

const mapStateToProps = (state) => {
  const { allowAllToCreateProjects, isOrgMode } = selectors.selectConfig(state);

  const currentUser = selectors.selectCurrentUser(state);
  const isAdmin = selectors.selectHasPermission(
    state,
    ResourceTypes.PLATFORM,
    0,
    Permissions.PROJECT_CREATE,
  );
  const projects = selectors.selectProjectsForCurrentUser(state);
  console.log('Projectscontainer');
  console.log(currentUser);
  console.log(projects);
  console.log('isAdmin value', isAdmin);

  return {
    currentUser,
    items: projects,
    canAdd: !isOrgMode && (allowAllToCreateProjects || isAdmin),
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      onAdd: entryActions.openProjectAddModal,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(Projects);
